// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemLineNumberColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the line number (#) column for item subtables.
// options.size: 'small' (11px, default) | 'middle' (14px)
function itemLineNumberColumn(options = {}) {
  const { size } = options;
  const fontSize = resolveItemFontSize(size, 11);

  return {
    title: '#',
    dataIndex: 'lineNumber',
    width: 40,
    align: 'center',
    render: (_, __, index) => (
      <Text type="secondary" style={{ fontSize }}>
        {index + 1}
      </Text>
    ),
  };
}

export default itemLineNumberColumn;
